import type { Security } from '@talos/kyoko';

/** Display / card lookup: instrument row only (`deal.Symbol`), no template fallback. */
export function resolveDealSecurityForCard(
  securitiesBySymbol: Map<string, Security>,
  deal: { Symbol: string; TemplateSymbol?: string }
): Security | undefined {
  return securitiesBySymbol.get(deal.Symbol);
}
